// extracted by mini-css-extract-plugin
export default {"grid":"Dashboard_grid__Sgfv-","cell":"Dashboard_cell__eritZ","centered":"Dashboard_centered__+6Szc"};